module.exports = __webpack_public_path__ + "static/media/WPM.bd1b82c7.jpg";